export default __webpack_public_path__ + "static/media/honda.f936559a.webp";